var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"base-radio",class:[
    `base-radio-${_vm.variant}`,
    {
      checked: _vm.checked,
      disabled: _vm.disabled
    }
  ]},[_c('input',{staticClass:"base-radio-input",attrs:{"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.optionValue,"checked":_vm.checked},on:{"change":_vm.handleChange}}),_c('span',{staticClass:"base-radio-marker",attrs:{"aria-hidden":"true"}}),(_vm.$slots.default)?_c('span',{staticClass:"base-radio-content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }